module.exports = __webpack_public_path__ + "static/media/StepVars.9ce90262.mp4";